'use client'

import { useQuery } from '@tanstack/react-query'

import { SyneriseCampaignRecommendationQueryParams } from 'lib/synerise'
import { QueryKey } from 'shared/api'

import { Cart } from '../../../types'
import { getRecommendedCartProducts } from '../api'
import { getCartProductsCodes } from '../utils'

interface UseQueryRecommendedCartProductsProps {
  cart: Cart | null
  token: string
  distributionCenterId: string
}

const useQueryRecommendedCartProducts = ({
  cart,
  token,
  distributionCenterId
}: UseQueryRecommendedCartProductsProps) => {
  const cartProductCodes = cart ? getCartProductsCodes(cart) : []
  const cartId = cart ? cart.id : ''

  const syneriseRecommendationQueryParams: SyneriseCampaignRecommendationQueryParams =
    {
      itemId: cartProductCodes
    }

  return useQuery({
    queryKey: [QueryKey.recommendedCartProducts, cartId, token],
    queryFn: () =>
      getRecommendedCartProducts({
        cartId,
        token,
        distributionCenterId,
        syneriseRecommendationQueryParams
      }),
    staleTime: 1000 * 60 // 1 minute
  })
}

export default useQueryRecommendedCartProducts
